import { createBrowserHistory } from 'history'

import { getUserConfirmation } from './components/NavigationConfirmModal'

// this history instance is used in various non-component files to redirect the user
// its also used in components via Router to keep the history in sync
export const history = createBrowserHistory({ getUserConfirmation })
